export default __webpack_public_path__ + "static/media/unauthorized-2.eb55b9ad.png";